import React from 'react';
import styled from '@benzinga/themetron';
import { Button } from '@benzinga/core-ui';
import { BzImage } from '@benzinga/image';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface AdvertisingCardProps {
  align: string;
  button_text: string;
  description: string;
  image: AdvertisingCardImage;
  link: string;
  title: string;
  height: number;
}

export interface AdvertisingCardImage {
  ID: number;
  id: number;
  title: string;
  filename: string;
  filesize: number;
  url: string;
  link: string;
  alt: string;
  author: string;
  description: string;
  caption: string;
  name: string;
  status: string;
  uploaded_to: number;
  date: Date;
  modified: Date;
  menu_order: number;
  mime_type: string;
  type: string;
  subtype: string;
  icon: string;
  width: number;
  height: number;
  sizes: Sizes;
}

export interface Sizes {
  thumbnail: string;
  'thumbnail-width': number;
  'thumbnail-height': number;
  medium: string;
  'medium-width': number;
  'medium-height': number;
  medium_large: string;
  'medium_large-width': number;
  'medium_large-height': number;
  large: string;
  'large-width': number;
  'large-height': number;
  '1536x1536': string;
  '1536x1536-width': number;
  '1536x1536-height': number;
  '2048x2048': string;
  '2048x2048-width': number;
  '2048x2048-height': number;
  'Multi Rating Pro Thumbnail': string;
  'Multi Rating Pro Thumbnail-width': number;
  'Multi Rating Pro Thumbnail-height': number;
  'slideshow-img': string;
  'slideshow-img-width': number;
  'slideshow-img-height': number;
  'web-stories-poster-portrait': string;
  'web-stories-poster-portrait-width': number;
  'web-stories-poster-portrait-height': number;
  'web-stories-publisher-logo': string;
  'web-stories-publisher-logo-width': number;
  'web-stories-publisher-logo-height': number;
  'web-stories-thumbnail': string;
  'web-stories-thumbnail-width': number;
  'web-stories-thumbnail-height': number;
}

export const AdvertisingCardBlock: React.FC<AdvertisingCardProps> = ({
  align,
  button_text,
  description,
  height,
  image,
  link,
  title,
}) => {
  return (
    <AdvertisingCardWrapper className={`advertising-card-wrapper align-${align} my-2 py-2`}>
      {image?.url && (
        <a href={link} rel="noreferrer" target="_blank">
          <Thumbnail $height={height}>
            <BzImage layout="fill" src={image.url} />
          </Thumbnail>
        </a>
      )}
      <div className="font-bold my-2 text-2xl">{title}</div>
      <div className="my-2 text-md">
        <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }} />
      </div>
      <div className="my-2">
        <a href={link} rel="noreferrer" target="_blank">
          <Button variant="primary">{button_text}</Button>
        </a>
      </div>
    </AdvertisingCardWrapper>
  );
};

export const AdvertisingCardWrapper = styled.div`
  border-top: solid 1px #ddd;
  border-bottom: solid 1px #ddd;
`;

const Thumbnail = styled.div<{ $height?: number }>`
  position: relative;
  height: ${({ $height }) => ($height ? `${$height}px` : '140px')};
  width: 100%;
  overflow: hidden;
`;
